// src/components/Form/salaryslip.jsx
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from '../../Context/UserContext';
import {
  FaCalendarAlt, FaUser, FaSave, FaPrint, FaFileInvoiceDollar, FaArrowLeft,
  FaTimes, FaCheck, FaCheckCircle, FaExclamationTriangle, FaCog, FaChevronLeft, FaChevronRight
} from 'react-icons/fa';
import { checkIsAdmin, checkIsGlobalAdmin } from '../../utils/authUtils';
import CustomerCustomizationModal from "./CustomerCustomizationModal";
import './CreateCustomerPage.css';

const CustomDatePicker = ({ value, onChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(() => value ? new Date(value) : new Date());
  const [dropdownPos, setDropdownPos] = useState({ top: '100%', bottom: 'auto', marginTop: '8px', marginBottom: 0 });
  const containerRef = React.useRef(null);
  
  const [dayInput, setDayInput] = useState('');
  const [monthInput, setMonthInput] = useState('');
  const [yearInput, setYearInput] = useState('');

  useEffect(() => {
    if (value) {
      const [y, m, d] = value.split('-');
      setYearInput(y);
      setMonthInput(m);
      setDayInput(d);
      setCurrentDate(new Date(y, parseInt(m)-1, parseInt(d)));
    }
  }, [value]);

  useEffect(() => {
    if (dayInput.length > 0 && monthInput.length > 0 && yearInput.length === 4) {
       const y = parseInt(yearInput);
       const m = parseInt(monthInput) - 1;
       const d = parseInt(dayInput);
       if (y > 1900 && y < 2100 && m >= 0 && m <= 11 && d >= 1 && d <= 31) {
         const dateStr = `${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
         if (dateStr !== value) {
            onChange(dateStr);
            setCurrentDate(new Date(y, m, d));
         }
       }
    }
  }, [dayInput, monthInput, yearInput, onChange, value]);

  const handleDaySelect = (day) => {
    const d = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    onChange(`${yyyy}-${mm}-${dd}`);
    setIsOpen(false);
  };
  
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  
  const firstDayOfMonth = new Date(year, month, 1).getDay(); 
  const startOffset = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  
  const days = [];
  for (let i = 0; i < startOffset; i++) days.push(null);
  for (let i = 1; i <= daysInMonth; i++) days.push(i);
  
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const toggleOpen = () => {
    if (disabled) return;
    if (!isOpen && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      if (window.innerHeight - rect.bottom < 350) {
        setDropdownPos({ top: 'auto', bottom: '100%', marginTop: 0, marginBottom: '8px' });
      } else {
        setDropdownPos({ top: '100%', bottom: 'auto', marginTop: '8px', marginBottom: 0 });
      }
    }
    setIsOpen(!isOpen);
  };

  return (
     <div style={{ position: 'relative' }} ref={containerRef}>
       <div 
         className={`field-input ${disabled ? 'disabled' : ''}`}
         style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: disabled ? 'not-allowed' : 'pointer', background: '#f8fafc', minHeight: '44px', fontWeight: '600', color: '#1e293b' }}
         onClick={toggleOpen}
       >
         <span>{value || 'YYYY-MM-DD'}</span>
         <FaCalendarAlt style={{ color: '#94a3b8' }} />
       </div>
       {isOpen && (
         <>
           <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }} onClick={() => setIsOpen(false)}></div>
           <div style={{ position: 'absolute', top: dropdownPos.top, bottom: dropdownPos.bottom, marginTop: dropdownPos.marginTop, marginBottom: dropdownPos.marginBottom, left: 0, background: '#fff', borderRadius: '16px', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)', padding: '20px', zIndex: 1000, width: '320px', border: '1px solid #f1f5f9' }}>
              
              {/* Quick Enter */}
              <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #f1f5f9' }}>
                <div style={{ fontSize: '12px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', marginBottom: '12px' }}>Quick Enter Date</div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '700', marginBottom: '4px', display: 'block' }}>Day</label>
                    <input type="text" placeholder="DD" maxLength="2" value={dayInput} onChange={e => setDayInput(e.target.value)} style={{ width: '100%', padding: '10px 0', borderRadius: '8px', border: 'none', background: '#f8fafc', textAlign: 'center', fontWeight: '600', color: '#475569' }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '700', marginBottom: '4px', display: 'block' }}>Month</label>
                    <input type="text" placeholder="MM" maxLength="2" value={monthInput} onChange={e => setMonthInput(e.target.value)} style={{ width: '100%', padding: '10px 0', borderRadius: '8px', border: 'none', background: '#f8fafc', textAlign: 'center', fontWeight: '600', color: '#475569' }} />
                  </div>
                  <div style={{ flex: 1.2 }}>
                    <label style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '700', marginBottom: '4px', display: 'block' }}>Year</label>
                    <input type="text" placeholder="YYYY" maxLength="4" value={yearInput} onChange={e => setYearInput(e.target.value)} style={{ width: '100%', padding: '10px 0', borderRadius: '8px', border: 'none', background: '#f8fafc', textAlign: 'center', fontWeight: '600', color: '#475569' }} />
                  </div>
                </div>
              </div>

              {/* Calendar Header */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <button type="button" onClick={(e) => { e.stopPropagation(); setCurrentDate(new Date(year, month - 1, 1)); }} style={{ background: '#f8fafc', border: 'none', width: '32px', height: '32px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1e293b' }}>
                  <FaChevronLeft />
                </button>
                <div style={{ fontSize: '16px', fontWeight: '800', color: '#1e293b' }}>
                  {monthNames[month]} <span style={{ marginLeft: '4px' }}>{year}</span>
                </div>
                <button type="button" onClick={(e) => { e.stopPropagation(); setCurrentDate(new Date(year, month + 1, 1)); }} style={{ background: '#f8fafc', border: 'none', width: '32px', height: '32px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1e293b' }}>
                  <FaChevronRight />
                </button>
              </div>

              {/* Calendar Grid */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', textAlign: 'center', marginBottom: '8px' }}>
                {['Mo', 'Tu', 'We', 'Th', 'Fri', 'Sa', 'Su'].map(d => (
                  <div key={d} style={{ fontSize: '12px', fontWeight: '800', color: '#1e293b', padding: '5px 0' }}>{d}</div>
                ))}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', textAlign: 'center' }}>
                {days.map((d, i) => {
                  if (!d) return <div key={`empty-${i}`}></div>;
                  const isSelected = value === `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
                  return (
                    <button
                      key={d}
                      type="button"
                      onClick={(e) => { e.stopPropagation(); handleDaySelect(d); }}
                      style={{
                        padding: '8px 0',
                        border: 'none',
                        background: isSelected ? '#604be8' : 'transparent',
                        color: isSelected ? '#fff' : '#1e293b',
                        fontWeight: '700',
                        fontSize: '14px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {d}
                    </button>
                  )
                })}
              </div>
           </div>
         </>
       )}
     </div>
  );
};

const CustomMonthPicker = ({ value, onChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [year, setYear] = useState(() => value ? parseInt(value.split('-')[0]) : new Date().getFullYear());
  const [dropdownPos, setDropdownPos] = useState({ top: '100%', bottom: 'auto', marginTop: '8px', marginBottom: 0 });
  const containerRef = React.useRef(null);

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const displayValue = value ? `${months[parseInt(value.split('-')[1]) - 1]} ${value.split('-')[0]}` : 'Select Month';

  const toggleOpen = () => {
    if (disabled) return;
    if (!isOpen && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      if (window.innerHeight - rect.bottom < 300) {
        setDropdownPos({ top: 'auto', bottom: '100%', marginTop: 0, marginBottom: '8px' });
      } else {
        setDropdownPos({ top: '100%', bottom: 'auto', marginTop: '8px', marginBottom: 0 });
      }
    }
    setIsOpen(!isOpen);
  };

  return (
    <div style={{ position: 'relative' }} ref={containerRef}>
       <div 
         className={`field-input ${disabled ? 'disabled' : ''}`}
         style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: disabled ? 'not-allowed' : 'pointer', background: '#f8fafc', minHeight: '44px', fontWeight: '600', color: '#1e293b' }}
         onClick={toggleOpen}
       >
         <span>{displayValue}</span>
         <FaCalendarAlt style={{ color: '#94a3b8' }} />
       </div>
       {isOpen && (
         <>
           <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }} onClick={() => setIsOpen(false)}></div>
           <div style={{ position: 'absolute', top: dropdownPos.top, bottom: dropdownPos.bottom, marginTop: dropdownPos.marginTop, marginBottom: dropdownPos.marginBottom, left: 0, background: '#fff', borderRadius: '16px', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)', padding: '20px', zIndex: 1000, width: '300px', border: '1px solid #f1f5f9' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <button type="button" onClick={(e) => { e.stopPropagation(); setYear(y => y - 1); }} style={{ background: '#f8fafc', border: 'none', width: '32px', height: '32px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1e293b' }}>
                  <FaChevronLeft />
                </button>
                <span style={{ fontSize: '16px', fontWeight: '800', color: '#1e293b' }}>{year}</span>
                <button type="button" onClick={(e) => { e.stopPropagation(); setYear(y => y + 1); }} style={{ background: '#f8fafc', border: 'none', width: '32px', height: '32px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1e293b' }}>
                  <FaChevronRight />
                </button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                 {months.map((m, i) => {
                   const monthStr = String(i + 1).padStart(2, '0');
                   const isSelected = value === `${year}-${monthStr}`;
                   return (
                     <button 
                       key={m}
                       type="button"
                       onClick={(e) => {
                          e.stopPropagation();
                          onChange(`${year}-${monthStr}`);
                          setIsOpen(false);
                       }}
                       style={{
                         padding: '12px 0',
                         borderRadius: '10px',
                         border: 'none',
                         background: isSelected ? '#604be8' : '#f8fafc',
                         color: isSelected ? '#fff' : '#1e293b',
                         fontWeight: '700',
                         fontSize: '14px',
                         cursor: 'pointer',
                         transition: 'all 0.2s ease'
                       }}
                     >
                       {m}
                     </button>
                   );
                 })}
              </div>
           </div>
         </>
       )}
    </div>
  );
};

// Simple Field Component mapped to new UI
const Field = ({ label, value }) => (
  <div className="form-field-group">
    <label className="field-label">{label}</label>
    <div className="field-input" style={{ display: 'flex', alignItems: 'center', minHeight: '44px', background: '#f8fafc' }}>
      {value || '-'}
    </div>
  </div>
);

const SalarySlip = ({ permissions: propPermissions }) => {
  const navigate = useNavigate();
  // Global State
  const { user, baseUrl, configLoading, getHeaders } = useContext(UserContext);
  const [searchParams] = useSearchParams();
  const slipId = searchParams.get('id');

  // Core Data
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // Selections & Dates
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [totalWorkingDays, setTotalWorkingDays] = useState(30);

  // Stats
  const [attendanceSummary, setAttendanceSummary] = useState(null);

  // Config
  const [companyName, setCompanyName] = useState('My Company');
  const [currency, setCurrency] = useState('₹');

  // Permissions
  const [canRead, setCanRead] = useState(false);
  const [canWrite, setCanWrite] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canCreate, setCanCreate] = useState(false);
  const [permsLoading, setPermsLoading] = useState(true);
  const [dataScope, setDataScope] = useState("All Data");
  const [showPermModal, setShowPermModal] = useState(false);
  const [permModalMsg, setPermModalMsg] = useState("");
  const [showCustomizeModal, setShowCustomizeModal] = useState(false);

  useEffect(() => {
    if (configLoading) return;

    const fetchPermissions = async () => {
      try {
        setPermsLoading(true);
        const userStr = localStorage.getItem('user');
        if (userStr) {
          const userObj = JSON.parse(userStr);
          const roleRaw = userObj.role || userObj.UserType || '';
          const isAdminRole = checkIsAdmin(userObj);
          const isGroupAdminRole = checkIsGlobalAdmin(userObj);

          if (roleRaw) {
            const userEmail = userObj.email || '';
            const url = `${baseUrl}/api/role-permissions?role=${encodeURIComponent(roleRaw)}&email=${userEmail}`;
            const response = await axios.get(url, { headers: getHeaders() });
            const perms = response.data.permissions || [];
            const pagePerm = perms.find(p => p.pageId === 'salary_slip' || p.pageId === 'salary_list');
            
            if (isAdminRole || isGroupAdminRole) {
              setCanRead(true);
              setCanWrite(true);
              setCanDelete(true);
              setCanCreate(true);
              setDataScope("All Data");
            } else if (pagePerm) {
              setCanRead(pagePerm.canRead === true);
              setCanWrite(pagePerm.canWrite === true);
              setCanDelete(pagePerm.canDelete === true);
              setCanCreate(pagePerm.canCreate === true);
              const scope = pagePerm.dataAccess || pagePerm.dataScope || "All Data";
              setDataScope(scope);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      } finally {
        setPermsLoading(false);
      }
    };
    fetchPermissions();
  }, [baseUrl, configLoading]);

  // Form Fields
  const [designation, setDesignation] = useState('');
  const [modeOfPayment, setModeOfPayment] = useState('Bank Transfer');
  const [postingDate, setPostingDate] = useState('');
  const [salaryStructure, setSalaryStructure] = useState('Kyle New');
  const [payrollFrequency, setPayrollFrequency] = useState('Monthly');
  const [letterHead, setLetterHead] = useState('Kyle');
  const [status, setStatus] = useState('Submitted');

  // Financials
  const [earnings, setEarnings] = useState([]);
  const [grossPay, setGrossPay] = useState(0);
  const [dailyRate, setDailyRate] = useState(0);
  const [leaveWithoutPayAmount, setLeaveWithoutPayAmount] = useState(0);

  // Roster (Deductions)
  const [rosterDeductions, setRosterDeductions] = useState([]);
  const [totalRosterDeduction, setTotalRosterDeduction] = useState(0);

  // Totals
  const [totalDeductions, setTotalDeductions] = useState(0);
  const [netPay, setNetPay] = useState(0);
  const [totalInWords, setTotalInWords] = useState('');
  const [grossYearToDate, setGrossYearToDate] = useState(0);
  const [monthToDate, setMonthToDate] = useState(0);

  const [preventAttendanceFetch, setPreventAttendanceFetch] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('Details');

  const formatCurrency = (val) => Number(val || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Initial Data Fetching
  useEffect(() => {
    if (configLoading) return;
    const currentBaseUrl = baseUrl || '';

    const fetchData = async () => {
      try {
        await Promise.all([
          getSettings(),
          getCompany(),
          getEmployees()
        ]);
      } catch (err) {
        console.error(err);
      }
    };

    const getSettings = async () => {
      try {
        const res = await axios.get(`${currentBaseUrl}/api/settings`, { headers: getHeaders() });
        const map = { 'USD': '$', 'INR': '₹', 'EUR': '€', 'GBP': '£', 'AED': 'AED' };
        setCurrency(map[res.data.currency] || res.data.currency || '₹');
      } catch { }
    };

    const getCompany = async () => {
      try {
        const res = await axios.get(`${currentBaseUrl}/api/company-details`, { headers: getHeaders() });
        if (res.data.companyDetails?.length) setCompanyName(res.data.companyDetails.slice(-1)[0].restaurantName);
      } catch { }
    };

    const getEmployees = async () => {
      try {
        const res = await axios.get(`${currentBaseUrl}/api/add-employee`, {
          headers: getHeaders(),
          params: {
            userId: user?.userId,
            role: user?.role,
            pageId: 'salary_slip' // Pass context for hierarchy filtering
          }
        });
        setEmployees(res.data || []);
      } catch { setError('Failed to fetch employees.'); setTimeout(() => setError(''), 3000); }
    };

    fetchData();
  }, [baseUrl, configLoading, user, dataScope]);

  // Load Slip
  useEffect(() => {
    const loadSlip = async () => {
      if (!slipId || !employees.length) return;
      try {
        const res = await axios.get(`${baseUrl}/api/salary-slip/${slipId}`, { headers: getHeaders() });
        const data = res.data;

        const emp = employees.find(e => e._id === data.employeeId);
        if (emp) setSelectedEmployee(emp);

        setPreventAttendanceFetch(true);
        setSelectedMonth(data.month);

        setEarnings(data.earnings || []);
        setRosterDeductions(data.rosterDeductions || data.rosterAdditions || []);

        setDesignation(data.designation);
        setLetterHead(data.letterHead);
        setModeOfPayment(data.modeOfPayment);
        setPayrollFrequency(data.payrollFrequency || 'Monthly');
        setSalaryStructure(data.salaryStructure || 'Kyle New');
        setStatus(data.status);
        setPostingDate(data.postingDate);
        setStartDate(data.startDate);
        setEndDate(data.endDate);

        setGrossPay(data.grossPay || 0);
        setNetPay(data.netPay || 0);
        setTotalDeductions(data.totalDeductions || 0);
        setGrossYearToDate(data.grossYearToDate || 0);
        setMonthToDate(data.netPay || 0);

        setAttendanceSummary({
          presentCount: data.presentCount,
          halfDayCount: data.halfDayCount,
          weeklyOffCount: data.weeklyOffCount,
          holidayCount: data.holidayCount,
          paidLeaveCount: data.paidLeaveCount,
          unpaidLeaveCount: data.unpaidLeaveCount,
          absentCount: data.absentCount,
          workingDays: data.workingDays,
          paymentDays: data.paymentDays
        });

      } catch (e) { console.error(e); setError('Failed to load salary slip.'); setTimeout(() => setError(''), 3000); }
    };
    loadSlip();
  }, [slipId, employees, baseUrl]);

  // Month
  useEffect(() => {
    if (selectedMonth) {
      const [y, m] = selectedMonth.split('-');
      const lastDay = new Date(parseInt(y), parseInt(m), 0);
      setTotalWorkingDays(lastDay.getDate());
      setStartDate(`${y}-${m}-01`);

      const today = new Date();
      const isCurrentMonth = today.getFullYear() === parseInt(y) && (today.getMonth() + 1) === parseInt(m);
      if (isCurrentMonth) {
        setEndDate(today.toISOString().slice(0, 10));
      } else {
        setEndDate(lastDay.toISOString().slice(0, 10));
      }
    }
  }, [selectedMonth]);

  // Fetch Attendance
  const fetchAttendance = async () => {
    if (!selectedEmployee) return;
    try {
      const [attRes, leaveRes] = await Promise.all([
        axios.get(`${baseUrl}/api/attendance`, {
          headers: getHeaders(),
          params: { month: selectedMonth, employee_id: selectedEmployee._id }
        }),
        axios.get(`${baseUrl}/api/leave-applications`, {
          headers: getHeaders(),
          params: {
            employee_id: selectedEmployee._id,
            status: 'APPROVED',
            userId: user?.userId || user?._id || user?.id,
            role: user?.role
          }
        })
      ]);

      const records = Array.isArray(attRes.data) ? attRes.data : (attRes.data.records || []);
      const allLeaves = leaveRes.data || [];
      const leaves = allLeaves.filter(l => (l.status || '').toLowerCase() === 'approved');

      const recordsByDate = {};
      records.forEach(r => {
        const date = r.attendance_date;
        if (!recordsByDate[date]) recordsByDate[date] = [];
        recordsByDate[date].push(r);
      });

      let presentDays = 0, halfDays = 0, offDays = 0, holidayDays = 0;
      let paidLeaveDays = 0, unpaidDays = 0, absentDays = 0;
      const rosterDates = [];

      const start = new Date(startDate);
      const end = new Date(endDate);

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const dateStr = d.toISOString().slice(0, 10);
        let status = '';
        const dayRecords = recordsByDate[dateStr];

        if (dayRecords && dayRecords.length > 0) {
          const primary = dayRecords[0];
          status = (primary.status || '').toLowerCase();
          const hasRoster = dayRecords.some(r => r.is_roster === true || r.is_roster === 'true' || r.isRoster === true || r.isRoster === 'true');
          if (hasRoster) rosterDates.push(dateStr);
        } else {
          const leave = leaves.find(l => {
            const s = l.from_date.split('T')[0];
            const e = l.to_date.split('T')[0];
            return dateStr >= s && dateStr <= e;
          });
          if (leave) {
            status = 'paid leave';
          } else {
            const dayNum = d.getDay();
            if (dayNum === 0 || dayNum === 6) status = 'weekly off';
          }
        }

        if (status.includes('present') || status === 'full day' || status === 'extended') presentDays++;
        else if (status.includes('half') || status.includes('halfday')) halfDays++;
        else if (status.includes('weekly') || status.includes('off day')) offDays++;
        else if (status.includes('holiday')) holidayDays++;
        else if (status.includes('paid leave')) paidLeaveDays++;
        else if (status.includes('leave without pay') || status.includes('on leave') || status === 'leave') unpaidDays++;
        else if (status.includes('absent')) absentDays++;
      }

      const working = presentDays + (halfDays * 0.5) + paidLeaveDays;
      const payment = working + offDays + holidayDays;

      setAttendanceSummary({
        presentCount: presentDays, halfDayCount: halfDays, weeklyOffCount: offDays,
        holidayCount: holidayDays, paidLeaveCount: paidLeaveDays, unpaidLeaveCount: unpaidDays,
        absentCount: absentDays, workingDays: working, paymentDays: payment
      });

      const newRosterDeductions = rosterDates.map(date => ({
        date: date, amount: 0, description: 'Roster Duty'
      }));

      setRosterDeductions(prev => {
        const merged = newRosterDeductions.map(newItem => {
          const existing = prev.find(p => p.date === newItem.date);
          return existing ? existing : newItem;
        });
        return merged.length > 0 ? merged : prev;
      });

      try {
        const yRes = await axios.get(`${baseUrl}/api/salary-slip/year-to-date`, {
          headers: getHeaders(),
          params: { employeeId: selectedEmployee._id, month: selectedMonth }
        });
        setGrossYearToDate(yRes.data.gross_year_to_date || 0);
      } catch { setGrossYearToDate(0); }

    } catch (e) {
      console.error('ATTENDANCE FETCH ERROR:', e);
      setError('Failed to fetch attendance');
      setTimeout(() => setError(''), 3000);
    }
  };

  useEffect(() => {
    if (selectedEmployee && selectedMonth && !preventAttendanceFetch) {
      fetchAttendance();
    }
  }, [selectedEmployee, selectedMonth, startDate, endDate, totalWorkingDays]);

  // Calculations
  useEffect(() => {
    if (!attendanceSummary) return;

    const baseGross = earnings.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    const rosterAddition = rosterDeductions.reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);
    setTotalRosterDeduction(rosterAddition);

    const g = baseGross + rosterAddition;
    setGrossPay(g);

    const rate = totalWorkingDays > 0 ? baseGross / totalWorkingDays : 0;
    setDailyRate(rate);

    const unpaidDays = totalWorkingDays - attendanceSummary.paymentDays;
    const lop = Math.max(0, unpaidDays * rate);
    setLeaveWithoutPayAmount(lop);

    const totalD = lop + rosterAddition;
    setTotalDeductions(totalD);

    const net = Math.max(0, g - totalD);
    setNetPay(net);
    setMonthToDate(net);
    setTotalInWords(numberToWords(net));

  }, [earnings, attendanceSummary, rosterDeductions, totalWorkingDays]);

  const numberToWords = (n) => {
    const num = parseFloat(n);
    if (isNaN(num)) return "Zero";
    return `${currency} ${num.toFixed(2)}`;
  };

  const handleEmployeeSelect = (e) => {
    const emp = employees.find(ep => ep._id === e.target.value);
    setSelectedEmployee(emp);
    setPreventAttendanceFetch(false);

    setRosterDeductions([]);
    setAttendanceSummary(null);

    if (emp && !slipId) {
      setEarnings([
        { component: 'Basic', amount: emp.basicSalary || 0 },
        { component: 'House Rent Allowance', amount: emp.hra || 0 },
        { component: 'Commuting Expenses', amount: emp.ta || 0 },
        ...(emp.oa ? [{ component: 'Other Allowances', amount: emp.oa }] : [])
      ]);
      setDesignation(emp.employeeDesignation);
      setPostingDate(emp.dateOfJoining);
    }
  };

  const updateRosterRow = (idx, field, val) => {
    const arr = [...rosterDeductions];
    arr[idx][field] = val;
    setRosterDeductions(arr);
  };

  const updateEarning = (idx, val) => {
    const arr = [...earnings];
    arr[idx].amount = val;
    setEarnings(arr);
  };

  const handleSave = async () => {
    if (!canWrite) {
      setPermModalMsg("You do not have permission to save salary slips.");
      setShowPermModal(true);
      return;
    }
    if (!selectedEmployee) { setError("Select Employee"); setTimeout(() => setError(''), 3000); return; }
    try {
      const payload = {
        employeeId: selectedEmployee._id,
        employeeName: selectedEmployee.name,
        employeeIdCode: selectedEmployee.employeeId,
        month: selectedMonth,
        grossSalary: grossPay,
        totalSalary: grossPay,
        netPay,
        grossPay,
        grossYearToDate,
        totalDeductions,
        dailyRate,
        fullCount: attendanceSummary?.presentCount || 0,
        offCount: attendanceSummary?.weeklyOffCount || 0,
        leaveWithoutPay: attendanceSummary?.unpaidLeaveCount || 0,
        absentCount: attendanceSummary?.absentCount || 0,
        paymentDays: attendanceSummary?.paymentDays || 0,
        presentCount: attendanceSummary?.presentCount || 0,
        halfDayCount: attendanceSummary?.halfDayCount || 0,
        weeklyOffCount: attendanceSummary?.weeklyOffCount || 0,
        holidayCount: attendanceSummary?.holidayCount || 0,
        paidLeaveCount: attendanceSummary?.paidLeaveCount || 0,
        unpaidLeaveCount: attendanceSummary?.unpaidLeaveCount || 0,
        workingDays: attendanceSummary?.workingDays || 0,
        designation,
        postingDate,
        payrollFrequency,
        startDate,
        endDate,
        salaryStructure,
        modeOfPayment,
        letterHead,
        status,
        earnings,
        deductions: [
          { component: 'Leave Without Pay', amount: leaveWithoutPayAmount },
          ...rosterDeductions.map(r => ({ component: `Roster: ${r.description || 'Roster Duty'} (${r.date})`, amount: parseFloat(r.amount || 0) }))
        ],
        rosterAdditions: rosterDeductions,
        rosterDeductions: rosterDeductions,
        totalRosterAmount: totalRosterDeduction
      };

      const url = slipId ? `${baseUrl}/api/salary-slip/${slipId}` : `${baseUrl}/api/salary-slip`;
      const method = slipId ? 'put' : 'post';
      await axios({ method, url, data: payload, headers: getHeaders() });

      setMessage("Saved Successfully!");
      setTimeout(() => setMessage(''), 2000);
      if (!slipId) {
        setTimeout(() => navigate('/salary-receipt-list', { state: { fromSave: true } }), 2000);
      }

    } catch (e) {
      console.error('Save error:', e.response?.data || e.message);
      setError(e.response?.data?.error || "Error saving");
      setTimeout(() => setError(''), 3000);
    }
  };

  const handlePrint = () => {
    if (!selectedEmployee) { setError("Select Employee to print"); setTimeout(() => setError(''), 3000); return; }
    const w = window.open('', '_blank');
    w.document.write(`
      <html>
      <head>
        <title>Salary Slip - ${selectedEmployee.name}</title>
        <style>
           body { font-family: 'Arial', sans-serif; padding: 40px; }
           .header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 15px; margin-bottom: 20px;}
           .header h1 { margin: 0; font-size: 24px; text-transform: uppercase; }
           .sub-header { font-size: 14px; margin-top: 5px; }
           .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-bottom: 20px; font-size: 13px; }
           .row { display: flex; justify-content: space-between; margin-bottom: 5px; }
           table { width: 100%; border-collapse: collapse; font-size: 12px; margin-bottom: 15px; }
           th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
           th { background: #f9f9f9; }
           .right { text-align: right; }
           .total-box { border: 2px solid #eee; padding: 15px; margin-top: 20px; }
           .net-pay { font-size: 18px; font-weight: bold; text-align: center; }
        </style>
      </head>
      <body>
         <div class="header">
            <h1>${companyName}</h1>
            <div class="sub-header">Salary Slip for ${selectedMonth}</div>
         </div>
         <div class="grid">
            <div>
               <div class="row"><strong>Employee ID:</strong> ${selectedEmployee.employeeId || ''}</div>
               <div class="row"><strong>Name:</strong> ${selectedEmployee.name}</div>
               <div class="row"><strong>Designation:</strong> ${designation}</div>
               <div class="row"><strong>Date of Joining:</strong> ${postingDate}</div>
            </div>
            <div>
               <div class="row"><strong>Status:</strong> ${status}</div>
               <div class="row"><strong>Payroll Mode:</strong> ${modeOfPayment}</div>
               <div class="row"><strong>Working Days:</strong> ${attendanceSummary?.workingDays || 0}</div>
               <div class="row"><strong>Paid Days:</strong> ${attendanceSummary?.paymentDays || 0}</div>
            </div>
         </div>
         <h3>Earnings</h3>
         <table>
           <thead><tr><th>Component</th><th class="right">Amount</th></tr></thead>
           <tbody>
              ${earnings.map(e => `<tr><td>${e.component}</td><td class="right">${currency} ${formatCurrency(e.amount)}</td></tr>`).join('')}
              <tr style="font-weight:bold; background:#f0f8ff;">
                 <td>Total Gross Pay</td>
                 <td class="right">${currency} ${formatCurrency(grossPay)}</td>
              </tr>
           </tbody>
         </table>
         <h3>Deductions</h3>
         <table>
           <thead><tr><th>Component</th><th class="right">Amount</th></tr></thead>
           <tbody>
              ${leaveWithoutPayAmount > 0 ? `<tr><td>Leave Without Pay</td><td class="right">${currency} ${formatCurrency(leaveWithoutPayAmount)}</td></tr>` : ''}
              ${rosterDeductions.map(r => `<tr><td>Roster: ${r.description || 'Roster Duty'} (${r.date || ''})</td><td class="right">${currency} ${formatCurrency(r.amount)}</td></tr>`).join('')}
              <tr style="font-weight:bold; background:#fff0f0;">
                 <td>Total Deductions</td>
                 <td class="right">${currency} ${formatCurrency(totalDeductions)}</td>
              </tr>
           </tbody>
         </table>
         <div class="total-box">
            <div class="net-pay">Net Payable: ${currency} ${formatCurrency(netPay)}</div>
            <div style="text-align:center; font-style:italic; margin-top:5px;">In Words: ${totalInWords}</div>
         </div>
         <div style="margin-top:50px; display:flex; justify-content:space-between; font-size:12px;">
            <div>Employee Signature</div>
            <div>Authorised Signatory</div>
         </div>
         <script>
           window.onload = function() { window.print(); }
         </script>
      </body>
      </html>
    `);
    w.document.close();
  };

  if (permsLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8fafc' }}>
        <p style={{ color: '#604be8', fontSize: '18px', fontWeight: 'bold' }}>Loading Permissions...</p>
      </div>
    );
  }

  const userStr = localStorage.getItem('user');
  const userObj = userStr ? JSON.parse(userStr) : {};
  const isAdminRole = checkIsAdmin(userObj);
  const isGroupAdminRole = checkIsGlobalAdmin(userObj);

  if (!canRead && !isAdminRole && !isGroupAdminRole && !permsLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8fafc' }}>
        <div style={{ textAlign: 'center', color: '#ef4444', fontSize: '18px', padding: '30px', background: '#fff', borderRadius: '15px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
          <h2>Access Denied</h2>
          <p>You do not have permission to view Salary Slip details.</p>
          <button className="save-btn" onClick={() => navigate('/admin')} style={{ marginTop: '20px', background: '#604be8' }}>Back to Admin</button>
        </div>
      </div>
    );
  }

  return (
    <div className="create-customer-container main-customer-page">
      {/* Messages / Popups */}
      {error && (
        <div style={{ position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', background: '#fef2f2', color: '#ef4444', padding: '16px 24px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '12px', fontWeight: '600', border: '1px solid #fee2e2', zIndex: 10001, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' }}>
          <FaExclamationTriangle style={{ fontSize: '20px' }} /> {error}
        </div>
      )}
      
      {message && (
        <div onClick={() => setMessage('')} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(8px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, cursor: 'pointer' }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', padding: '40px 32px', borderRadius: '24px', width: '90%', maxWidth: '440px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', cursor: 'default' }}>
            <div style={{ width: '84px', height: '84px', borderRadius: '50%', background: '#ecfdf5', color: '#10b981', border: '2px solid #a7f3d0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '38px', marginBottom: '24px' }}>
              <FaCheckCircle />
            </div>
            <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#1e293b', margin: '0 0 12px 0' }}>Success</h3>
            <p style={{ fontSize: '16px', color: '#64748b', margin: 0, fontWeight: '500' }}>{message}</p>
          </div>
        </div>
      )}

      {showPermModal && (
        <div className="add-modal-overlay" onClick={() => setShowPermModal(false)}>
          <div className="add-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '440px', textAlign: 'center' }}>
            <div className="modal-header" style={{ background: 'linear-gradient(135deg, #ef4444, #dc2626)' }}>
              <span>Permission Denied</span>
              <button className="close-modal-btn" onClick={() => setShowPermModal(false)}><FaTimes /></button>
            </div>
            <div className="modal-body">
              <p style={{ color: '#1e293b', fontWeight: '500' }}>{permModalMsg}</p>
            </div>
            <div className="modal-footer" style={{ justifyContent: 'center' }}>
              <button className="save-btn" onClick={() => setShowPermModal(false)} style={{ background: '#64748b' }}>Understood</button>
            </div>
          </div>
        </div>
      )}

      <div className="customer-header-section">
        <div className="header-left">
          <button onClick={() => navigate('/salary-receipt-list')} className="header-back-btn print-hidden">
            <FaArrowLeft /> Back
          </button>
        </div>
        <div className="header-center">
          <h1>{slipId ? 'Edit' : 'New'} Salary Slip</h1>
        </div>
        <div className="header-right">
          <div className="header-actions print-hidden">
            {(isAdminRole || isGroupAdminRole) && (
              <button onClick={() => setShowCustomizeModal(true)} className="save-btn" style={{ backgroundColor: '#00d284', width: 'auto', padding: '0 20px' }}>
                <FaCog /> Customize
              </button>
            )}
            <button onClick={handlePrint} className="save-btn" style={{ backgroundColor: '#f59e0b', width: 'auto', padding: '0 20px' }}>
              <FaPrint /> Print
            </button>
            <button onClick={handleSave} className="save-btn" style={{ backgroundColor: '#604be8', width: 'auto', padding: '0 20px' }}>
              <FaSave /> Save
            </button>
          </div>
        </div>
      </div>

      <div className="customer-scroll-body">
        <div className="form-sections-wrapper">
          
          {/* Selections Section */}
          <div className="form-section-card theme-blue print-hidden" style={{ marginBottom: '24px' }}>
            <div className="section-header" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #f1f5f9' }}>
              <div className="section-icon" style={{ background: '#e0e7ff', color: '#4f46e5', width: '40px', height: '40px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>
                <FaCalendarAlt />
              </div>
              <h2 style={{ margin: 0, fontSize: '18px', color: '#1e293b' }}>Select Salary Period & Employee</h2>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
              <div className="form-field-group">
                <label className="field-label">Month</label>
                <CustomMonthPicker value={selectedMonth} onChange={setSelectedMonth} disabled={!!slipId} />
              </div>
              <div className="form-field-group">
                <label className="field-label">Employee</label>
                <select className="field-input" value={selectedEmployee?._id || ''} onChange={handleEmployeeSelect} disabled={!!slipId}>
                  <option value="">-- Select Employee --</option>
                  {employees.map(e => <option key={e._id} value={e._id}>{e.name} ({e.employeeId})</option>)}
                </select>
              </div>
            </div>
            {employees.length === 0 && (
              <div style={{ marginTop: '16px', color: '#64748b', fontStyle: 'italic' }}>Loading Employees...</div>
            )}
          </div>

          {/* Details Section */}
          {selectedEmployee && attendanceSummary ? (
            <>
              {/* Tab Navigation */}
              <div className="print-hidden" style={{ display: 'flex', gap: '8px', marginBottom: '24px', overflowX: 'auto', paddingBottom: '4px' }}>
                {['Details', 'Payment Days', 'Earnings & Deductions', 'Net Pay Info'].map(t => (
                  <button
                    key={t}
                    onClick={() => setActiveTab(t)}
                    style={{
                      padding: '12px 24px',
                      borderRadius: '14px',
                      border: 'none',
                      fontSize: '14px',
                      fontWeight: '700',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      background: activeTab === t ? '#604be8' : '#fff',
                      color: activeTab === t ? '#fff' : '#64748b',
                      boxShadow: activeTab === t ? '0 4px 12px rgba(96,75,232,0.3)' : '0 2px 4px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {t}
                  </button>
                ))}
              </div>

              <div className="form-section-card theme-blue" style={{ marginBottom: '24px' }}>
                
                {/* TAB 1: DETAILS */}
                {activeTab === 'Details' && (
                  <div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <Field label="Employee ID" value={selectedEmployee.employeeId} />
                        <Field label="Name" value={selectedEmployee.name} />
                        <Field label="Designation" value={designation} />
                        <Field label="Join Date" value={postingDate} />
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                          <div className="form-field-group">
                            <label className="field-label">Start Date</label>
                            <CustomDatePicker value={startDate} onChange={setStartDate} />
                          </div>
                          <div className="form-field-group">
                            <label className="field-label">End Date</label>
                            <CustomDatePicker value={endDate} onChange={setEndDate} />
                          </div>
                        </div>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div className="form-field-group">
                          <label className="field-label">Mode of Payment</label>
                          <select className="field-input" value={modeOfPayment} onChange={e => setModeOfPayment(e.target.value)}>
                            <option>Bank Transfer</option><option>Cash</option><option>Cheque</option>
                          </select>
                        </div>
                        <Field label="Payroll Freq" value={payrollFrequency} />
                        <Field label="Status" value={status} />
                      </div>
                    </div>
                  </div>
                )}

                {/* TAB 2: PAYMENT DAYS */}
                {activeTab === 'Payment Days' && (
                  <div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px' }}>
                      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', padding: '24px', borderRadius: '16px', textAlign: 'center' }}>
                        <div style={{ fontSize: '13px', color: '#64748b', fontWeight: '700', marginBottom: '8px' }}>TOTAL DAYS</div>
                        <div style={{ fontSize: '28px', fontWeight: '800', color: '#1e293b' }}>{totalWorkingDays}</div>
                      </div>
                      <div style={{ background: '#ecfdf5', border: '1px solid #d1fae5', padding: '24px', borderRadius: '16px', textAlign: 'center' }}>
                        <div style={{ fontSize: '13px', color: '#059669', fontWeight: '700', marginBottom: '8px' }}>PRESENT</div>
                        <div style={{ fontSize: '28px', fontWeight: '800', color: '#065f46' }}>{attendanceSummary.presentCount}</div>
                      </div>
                      <div style={{ background: '#fff7ed', border: '1px solid #ffedd5', padding: '24px', borderRadius: '16px', textAlign: 'center' }}>
                        <div style={{ fontSize: '13px', color: '#ea580c', fontWeight: '700', marginBottom: '8px' }}>HALF DAYS</div>
                        <div style={{ fontSize: '28px', fontWeight: '800', color: '#9a3412' }}>{attendanceSummary.halfDayCount}</div>
                      </div>
                      <div style={{ background: '#eff6ff', border: '1px solid #dbeafe', padding: '24px', borderRadius: '16px', textAlign: 'center' }}>
                        <div style={{ fontSize: '13px', color: '#2563eb', fontWeight: '700', marginBottom: '8px' }}>PAID LEAVES</div>
                        <div style={{ fontSize: '28px', fontWeight: '800', color: '#1e40af' }}>{attendanceSummary.paidLeaveCount}</div>
                      </div>
                      <div style={{ background: '#fef2f2', border: '1px solid #fee2e2', padding: '24px', borderRadius: '16px', textAlign: 'center' }}>
                        <div style={{ fontSize: '13px', color: '#dc2626', fontWeight: '700', marginBottom: '8px' }}>UNPAID/ABSENT</div>
                        <div style={{ fontSize: '28px', fontWeight: '800', color: '#991b1b' }}>{attendanceSummary.unpaidLeaveCount + attendanceSummary.absentCount}</div>
                      </div>
                    </div>
                    <div style={{ marginTop: '24px', background: '#f1f5f9', padding: '20px 24px', borderRadius: '14px', border: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: '700', color: '#334155', fontSize: '16px' }}>Final Payment Days:</span>
                      <span style={{ fontSize: '24px', fontWeight: '800', color: '#10b981' }}>{attendanceSummary.paymentDays} / {totalWorkingDays}</span>
                    </div>
                  </div>
                )}

                {/* TAB 3: EARNINGS & DEDUCTIONS */}
                {activeTab === 'Earnings & Deductions' && (
                  <div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
                      <div style={{ background: '#f8fafc', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#059669', margin: '0 0 20px 0', paddingBottom: '12px', borderBottom: '2px solid #10b981' }}>Earnings</h3>
                        {earnings.map((earning, idx) => (
                          <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#475569' }}>{earning.component}</span>
                            <input
                              type="number"
                              className="field-input"
                              value={earning.amount}
                              onChange={(e) => updateEarning(idx, parseFloat(e.target.value) || 0)}
                              style={{ width: '140px', textAlign: 'right', background: '#fff' }}
                            />
                          </div>
                        ))}
                      </div>

                      <div style={{ background: '#f8fafc', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#dc2626', margin: '0 0 20px 0', paddingBottom: '12px', borderBottom: '2px solid #ef4444' }}>Deductions</h3>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', padding: '12px', background: '#fef2f2', borderRadius: '10px', color: '#b91c1c' }}>
                          <span style={{ fontWeight: '600' }}>Loss of Pay ({totalWorkingDays - attendanceSummary.paymentDays} days)</span>
                          <span style={{ fontWeight: '800' }}>{currency} {formatCurrency(leaveWithoutPayAmount)}</span>
                        </div>
                        {rosterDeductions.length > 0 && (
                          <>
                            <h4 style={{ fontSize: '12px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', marginBottom: '12px' }}>Roster Deductions</h4>
                            {rosterDeductions.map((rd, i) => (
                              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#475569' }}>{rd.date}</span>
                                <input
                                  type="number"
                                  className="field-input"
                                  placeholder="Amount"
                                  value={rd.amount}
                                  onChange={(e) => updateRosterRow(i, 'amount', parseFloat(e.target.value) || 0)}
                                  style={{ width: '140px', textAlign: 'right', background: '#fff' }}
                                />
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* TAB 4: NET PAY */}
                {activeTab === 'Net Pay Info' && (
                  <div>
                    <div style={{ background: 'linear-gradient(135deg, #1e293b, #0f172a)', color: 'white', padding: '40px', borderRadius: '20px', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }}>
                      <div style={{ fontSize: '14px', fontWeight: '700', color: '#94a3b8', marginBottom: '12px', letterSpacing: '1px' }}>NET PAYABLE FOR {selectedMonth}</div>
                      <div style={{ fontSize: '56px', fontWeight: '800', color: '#fff', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>{currency} {formatCurrency(netPay)}</div>
                      <div style={{ marginTop: '20px', fontSize: '15px', color: '#cbd5e1', fontStyle: 'italic' }}>{totalInWords}</div>
                    </div>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px', marginTop: '32px' }}>
                      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', padding: '24px', borderRadius: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#64748b' }}>GROSS PAY</div>
                        <div style={{ fontSize: '28px', fontWeight: '800', color: '#059669' }}>{currency} {formatCurrency(grossPay)}</div>
                      </div>
                      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', padding: '24px', borderRadius: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#64748b' }}>TOTAL DEDUCTIONS</div>
                        <div style={{ fontSize: '28px', fontWeight: '800', color: '#dc2626' }}>{currency} {formatCurrency(totalDeductions)}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div style={{ padding: '80px 20px', textAlign: 'center', background: '#f8fafc', borderRadius: '20px', border: '2px dashed #cbd5e1' }}>
              <FaUser style={{ fontSize: '64px', color: '#94a3b8', marginBottom: '20px', opacity: 0.5 }} />
              <h3 style={{ margin: 0, color: '#334155', fontSize: '20px' }}>Please select an employee to generate salary slip</h3>
            </div>
          )}

        </div>
      </div>

      <CustomerCustomizationModal
        isOpen={showCustomizeModal}
        onClose={() => setShowCustomizeModal(false)}
        onRefresh={() => {}}
        targetDocType="Salary Slip"
      />
    </div>
  );
};

export default SalarySlip;
